import React from "react"
import { Trans } from "@lingui/macro"
import { Button, ButtonAsButtonProps } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import { usePageTransition } from "../../app-core/_common/hooks/use-page-transition"

type Props = {
    full?: boolean
    onClick: ButtonAsButtonProps["onClick"]
    disabled: boolean
    loading?: boolean
    className?: string
}

const NextButton: React.FC<React.PropsWithChildren<Props>> = ({
    full,
    onClick,
    disabled,
    loading = false,
    className,
}) => {
    const { isTransitioning } = usePageTransition()
    const isTransitioningFinal = isTransitioning || loading
    const finalClassName = clsx("cy-next-btn", className)

    return (
        <Button
            renderAs="button"
            size="regular"
            variant="accent"
            onClick={onClick}
            disabled={disabled || isTransitioning}
            iconName="arrow-right"
            dataContentPiece="next-button"
            className={finalClassName}
            full={full}
            loading={isTransitioningFinal}
        >
            <Trans>Next</Trans>
        </Button>
    )
}

export default NextButton
